import NewsSimple from './NewsSimple'

class NewsDetails extends NewsSimple {
  /**
   * 资讯、公告类型（1-资讯 2-公告）
   */
  type = 1
  /**
   * 被阅读次数
   */
  readCount = 0
  /**
   * 封面图片路径
   */
  photoUrl = ''
}

export default NewsDetails
